import React from 'react';
import { AppProvider, useApp } from './context/AppContext';
import LoadingSpinner from './components/LoadingSpinner';
import LoginScreen from './screens/LoginScreen';
import Dashboard from './screens/Dashboard';
import AccountDetail from './screens/AccountDetail';
import TransactionDetail from './screens/TransactionDetail';
import AddTransaction from './screens/AddTransaction';
import LoansScreen from './screens/LoansScreen';
import LoanDetail from './screens/LoanDetail';
import ConfirmationScreen from './screens/ConfirmationScreen';

const AppContent = () => {
  const { screen, initializing } = useApp();

  // Show loading screen while initializing (checking for saved token)
  if (initializing) {
    return <LoadingSpinner />;
  }

  // Handle edit transaction screen
  if (screen === 'editTransaction') {
    window.location.hash = '#edit';
    return <AddTransaction />;
  }

  switch (screen) {
    case 'login':
      return <LoginScreen />;
    case 'dashboard':
      return <Dashboard />;
    case 'accountDetail':
      return <AccountDetail />;
    case 'transactionDetail':
      return <TransactionDetail />;
    case 'add':
      return <AddTransaction />;
    case 'loans':
      return <LoansScreen />;
    case 'loanDetail':
      return <LoanDetail />;
    case 'confirmation':
      return <ConfirmationScreen />;
    default:
      return <Dashboard />;
  }
};

export default function BuxferApp() {
  return (
    <AppProvider>
      <AppContent />
    </AppProvider>
  );
}
